import React from "react";
import { HashRouter, Route, Switch, Redirect } from "react-router-dom";
import JssProvider from "react-jss/lib/JssProvider";
import { createGenerateClassName } from "@material-ui/core/styles";

// components
import Layout from "./Layout";
import BillingLayout from "./BillingLayout";

// pages
import Error from "../pages/error";
import Login from "../pages/login";
import checkTokenService from "../services/checkToken";
import Cookies from "universal-cookie";
import { CircularProgress } from "@material-ui/core";
// context
import { useUserState } from "../context/UserContext";
import Constants from "../utils/consts";
import EventResponse from "../pages/eventResponse/EventResponse";
import CancelReservation from "../pages/cancelResevation/CancelResevation";

const generateClassName = createGenerateClassName({
  dangerouslyUseGlobalCSS: true, // won't minify CSS classnames when true
  productionPrefix: "c", // 'jss' by default
});

var isAuthenticated;

export default class App extends React.Component {
  constructor() {
    super();
    this.state = {};
  }

  async componentDidMount() {
    this.setState({ isLoading: true });
    const cookies = new Cookies();
    var token = cookies.get("token", { path: "/" });
    var uname = cookies.get("username", { path: "/" });
    isAuthenticated = await checkTokenService(uname, token);
    this.setState({ isLoading: false });
  }

  render() {
    if (this.state.isLoading === true) {
      return <div />;
    }

    const cookies = new Cookies();
    const username = cookies.get("username", { path: "/" });
    const userType = cookies.get("userType", { path: "/" });
    const brokerType = cookies.get("brokerType", { path: "/" });

    var redirectUrl = "";
    if (userType == 2 && brokerType == "company")
      redirectUrl = "/app/companiesBroker";
    else if (userType == 2 && brokerType == "investor")
      redirectUrl = "/app/investorsBroker";
    else if (username == "admin") redirectUrl = "/app/corsi";
    else if (userType == 4 && username === "phoneop")
      redirectUrl = "/app/dachiamare";
    else if (userType == 4) redirectUrl = "/app/dashboard";
    else if (username == "billing") redirectUrl = "/billing/corsi";
    else redirectUrl = "/app/eventslist";

    return (
      <JssProvider generateClassName={generateClassName}>
        <HashRouter>
          <Switch>
            <Route
              exact
              path="/"
              render={() => <Redirect to={redirectUrl} />}
            />
            <PrivateRoute
              path={Constants.apisFolder}
              render={() => <Redirect to={redirectUrl} />}
            />
            <PrivateRoute path="/app" component={Layout} />
            <PublicRoute path="/login" component={Login} />
            <PublicRoute path="/event-response" component={EventResponse} />
            <PublicRoute
              path="/cancel-reservation"
              component={CancelReservation}
            />
            <Route component={Error} />
          </Switch>
        </HashRouter>
      </JssProvider>
    );
  }
}

// #######################################################################

function PrivateRoute({ component, ...rest }) {
  return (
    <Route
      {...rest}
      render={(props) =>
        isAuthenticated ? (
          React.createElement(component, props)
        ) : (
          <Redirect
            to={{
              pathname: "/login",
              state: {
                from: props.location,
              },
            }}
          />
        )
      }
    />
  );
}

function PublicRoute({ component, path, ...rest }) {
  if (path === "/login")
    return (
      <Route
        {...rest}
        render={(props) =>
          isAuthenticated ? (
            <Redirect
              to={{
                pathname: "/",
              }}
            />
          ) : (
            React.createElement(component, props)
          )
        }
      />
    );
  return (
    <Route
      {...rest}
      render={(props) => React.createElement(component, props)}
    />
  );
}
